import { useEffect, useState } from "react";
import { getMyRoles } from "@/lib/auth/roles";

export function useIsAdmin() {
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    let mounted = true;
    (async () => {
      const roles = await getMyRoles();
      if (!mounted) return;
      setIsAdmin(roles.includes("admin"));
      setLoading(false);
    })();
    return () => { mounted = false; };
  }, []);

  return { loading, isAdmin };
}